// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `intro-flow {
  --header-height: 5px;
  --progress-bar-height: 5px;
  isolation: isolate;
  z-index: 10;
  position: absolute;
  background-color: var(--motes-dark);
  top: 0;
  bottom: 0;
  height: 100%;
  touch-action: none;
  padding-top: var(--safe-area-top);
}
intro-flow .progress-container {
  top: calc(var(--header-height) - var(--progress-bar-height));
  height: var(--progress-bar-height);
  right: 0;
  left: 0;
  background-color: transparent;
  transition: 0.2s;
}
intro-flow .progress-bar {
  background-color: var(--primary-color);
  transition: width 0.2s ease 0s;
  display: block;
  height: inherit;
}
intro-flow .progress-container.roll-out {
  transform: translateY(calc(-1 * var(--progress-bar-height)));
  transition: transform 0.3s ease-out;
}
intro-flow .page-container {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
intro-flow .back-button {
  pointer-events: initial;
  margin-top: 10px;
  text-transform: uppercase;
  font-family: "Gothic";
  color: #fff;
  padding: var(--motes-padding);
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
}
intro-flow .back-button svg-icon {
  font-size: 14pt;
  line-height: 100%;
}
intro-flow .back-button svg-icon span {
  display: flex;
}
intro-flow .back-button.roll-out {
  transform: translateY(calc(-1 * (1em + 10px + 2 * var(--motes-padding))));
  transition: transform 0.3s ease-out;
}
intro-flow .map-background {
  height: 56%;
  top: 10%;
  pointer-events: none;
  background-color: var(--motes-dark);
  background-image: url("https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Fbackgrounds%2Fintro-flow-map.webp?alt=media&token=c04f2272-b5ee-4a10-8d73-1123a8cd5855");
  background-repeat: no-repeat;
  background-size: cover;
}
intro-flow .map-background, intro-flow .back-button, intro-flow .progress-container {
  transform: translateX(100%);
  position: fixed;
  z-index: 0;
  width: 100%;
}
intro-flow .icon-container, intro-flow motes-modal {
  position: fixed;
  z-index: 5;
}
intro-flow .icon-container.hide, intro-flow .map-background.active.hide, intro-flow .map-background.place_active.hide, intro-flow .back-button.hide {
  z-index: 0;
  opacity: 0;
  transition: z-index 0.2s step-end, opacity 0.2s linear;
  pointer-events: none;
}
intro-flow .icon-container {
  opacity: 1;
  transition: opacity 0.6s;
  color: var(--primary-color);
  top: 30vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
intro-flow .icon-container tutorial-animation {
  width: 100%;
  max-width: var(--max-width);
}
intro-flow .icon-container .circle {
  position: relative;
  border-radius: 100%;
  height: 16vh;
}
intro-flow .icon-container .circle svg-morph, intro-flow .icon-container .circle svg-icon {
  font-size: 16vh;
  z-index: 0;
}
intro-flow .icon-container .circle svg-morph {
  position: absolute;
}
intro-flow .icon-container .circle svg-icon {
  position: relative;
}
intro-flow .icon-container p {
  margin-top: 1em;
}
intro-flow .icon-container .circle.animate {
  transform: scale(1);
  animation: pulse 1s infinite;
}
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }
  70% {
    transform: scale(1.1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}
intro-flow .icon-container .loading-message {
  opacity: 1;
  transition: opacity 0.3s;
  font-size: 15pt;
  height: 1em;
  font-family: "Century Gothic", Gothic, sans-serif;
  text-align: center;
}
intro-flow .icon-container .loading-message.hide {
  opacity: 0;
  transition: 0.3s;
}
intro-flow intro-flow-page {
  position: fixed;
  z-index: 0;
  pointer-events: none;
  transform: translateX(100%);
  top: 0;
}
intro-flow .active {
  transform: translateX(0%);
  transition: transform 0.3s ease-in-out;
  z-index: 4;
}
intro-flow .left {
  transform: translateX(-100%);
  transition: transform 0.3s ease-in-out;
  z-index: 4;
}
intro-flow .right {
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
  z-index: 4;
}
intro-flow .place_left {
  transform: translateX(-100%);
  z-index: 0;
  pointer-events: none;
}
intro-flow .place_right {
  transform: translateX(100%);
  z-index: 0;
  pointer-events: none;
}
intro-flow .place_active {
  transform: translateX(0%);
  z-index: 4;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/intro-flow/intro-flow.component.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,0BAAA;EAEA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,mCAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;AAAJ;AAEI;EACI,4DAAA;EACA,kCAAA;EACA,QAAA;EACA,OAAA;EACA,6BAAA;EACA,gBAAA;AAAR;AAGI;EACI,sCAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;AADR;AAII;EACI,4DAAA;EACA,mCAAA;AAFR;AAKI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;AAHR;AAMI;EACI,uBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,aAAA;EACA,mBAAA;AAJR;AAMQ;EACI,eAAA;EACA,iBAAA;AAJZ;AAMY;EACI,aAAA;AAJhB;AASI;EACI,yEAAA;EACA,mCAAA;AAPR;AAUI;EACI,WAAA;EACA,QAAA;EACA,oBAAA;EACA,mCAAA;EACA,kMAAA;EACA,4BAAA;EACA,sBAAA;AARR;AAWI;EACI,2BAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;AATR;AAYI;EACI,eAAA;EACA,UAAA;AAVR;AAaI;EACI,UAAA;EACA,UAAA;EACA,sDAAA;EACA,oBAAA;AAXR;AAcI;EACI,UAAA;EACA,wBAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAZR;AAcQ;EACI,WAAA;EACA,2BAAA;AAZZ;AAeQ;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;AAbZ;AAeY;EACI,eAAA;EACA,UAAA;AAbhB;AAgBY;EACI,kBAAA;AAdhB;AAiBY;EACI,kBAAA;AAfhB;AAmBQ;EACI,eAAA;AAjBZ;AAoBQ;EACI,mBAAA;EACA,4BAAA;AAlBZ;AAqBQ;EACI;IACI,mBAAA;IACA,sCAAA;EAnBd;EAsBU;IACI,qBAAA;IACA,uCAAA;EApBd;EAuBU;IACI,mBAAA;IACA,oCAAA;EArBd;AACF;AAwBO;EACK,UAAA;EACA,wBAAA;EACA,eAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AAtBZ;AAyBQ;EACI,UAAA;EACA,gBAAA;AAvBZ;AA2BI;EACI,eAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,MAAA;AAzBR;AA4BI;EACI,yBAAA;EACA,sCAAA;EACA,UAAA;AA1BR;AA6BI;EACI,4BAAA;EACA,sCAAA;EACA,UAAA;AA3BR;AA8BI;EACI,2BAAA;EACA,sCAAA;EACA,UAAA;AA5BR;AA+BI;EACI,4BAAA;EACA,UAAA;EACA,oBAAA;AA7BR;AAgCI;EACI,2BAAA;EACA,UAAA;EACA,oBAAA;AA9BR;AAiCI;EACI,yBAAA;EACA,UAAA;AA/BR","sourcesContent":["intro-flow {\n    --header-height: 5px;\n    --progress-bar-height: 5px;\n\n    isolation: isolate;\n    z-index: 10;\n    position: absolute;\n    background-color: var(--motes-dark);\n    top: 0;\n    bottom: 0;\n    height: 100%;\n    touch-action: none;\n    padding-top: var(--safe-area-top);\n\n    .progress-container {\n        top: calc(var(--header-height) - var(--progress-bar-height));\n        height: var(--progress-bar-height);\n        right: 0;\n        left: 0;\n        background-color: transparent;\n        transition: 0.2s;\n    }\n    \n    .progress-bar {\n        background-color: var(--primary-color);\n        transition: width 0.2s ease 0s;\n        display: block;\n        height: inherit;\n    }\n    \n    .progress-container.roll-out {\n        transform: translateY(calc(-1 * var(--progress-bar-height)));\n        transition: transform 0.3s ease-out;;\n    }  \n\n    .page-container {\n        overflow: hidden;\n        width: 100%;\n        height: 100%;\n    }\n    \n    .back-button {\n        pointer-events: initial;\n        margin-top: 10px;\n        text-transform: uppercase;\n        font-family: 'Gothic';\n        color: #fff;\n        padding: var(--motes-padding);\n        cursor: pointer;\n        width: fit-content;\n        display: flex;\n        align-items: center;\n        \n        svg-icon {\n            font-size: 14pt;\n            line-height: 100%;\n\n            span {\n                display: flex;\n            }\n        }\n    }\n    \n    .back-button.roll-out {\n        transform: translateY(calc(-1 * (1em + 10px + 2 * var(--motes-padding))));\n        transition: transform 0.3s ease-out;;\n    }\n    \n    .map-background {\n        height: 56%;\n        top: 10%;\n        pointer-events: none;\n        background-color: var(--motes-dark);\n        background-image: url(\"https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-images%2Fbackgrounds%2Fintro-flow-map.webp?alt=media&token=c04f2272-b5ee-4a10-8d73-1123a8cd5855\");\n        background-repeat: no-repeat;\n        background-size: cover;\n    }\n\n    .map-background, .back-button, .progress-container {\n        transform: translateX(100%);\n        position: fixed;\n        z-index: 0;\n        width: 100%;\n    }\n    \n    .icon-container, motes-modal {\n        position: fixed;\n        z-index: 5;\n    }\n\n    .icon-container.hide, .map-background.active.hide, .map-background.place_active.hide, .back-button.hide {\n        z-index: 0;\n        opacity: 0;\n        transition: z-index 0.2s step-end, opacity 0.2s linear;\n        pointer-events: none;\n    }\n\n    .icon-container {\n        opacity: 1;\n        transition: opacity 0.6s;\n        color: var(--primary-color);\n        top: 30vh;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n\n        tutorial-animation {\n            width: 100%;\n            max-width: var(--max-width);\n        }\n\n        .circle {\n            position: relative;\n            border-radius: 100%;\n            height: 16vh;\n            \n            svg-morph, svg-icon {\n                font-size: 16vh;\n                z-index: 0;\n            }\n\n            svg-morph {\n                position: absolute;\n            }\n\n            svg-icon {\n                position: relative;\n            }\n        }\n\n        p {\n            margin-top: 1em;\n        }\n\n        .circle.animate {\n            transform: scale(1);\n            animation: pulse 1s infinite;\n        }  \n        \n        @keyframes pulse {\n            0% {\n                transform: scale(1);\n                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);\n            }\n        \n            70% {\n                transform: scale(1.1);\n                box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);\n            }\n        \n            100% {\n                transform: scale(1);\n                box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);\n            }\n       }\n\n       .loading-message {\n            opacity: 1;\n            transition: opacity 0.3s;\n            font-size: 15pt;\n            height: 1em;\n            font-family: \"Century Gothic\", Gothic, sans-serif;\n            text-align: center;\n        }\n\n        .loading-message.hide {\n            opacity: 0;\n            transition: 0.3s;\n        }\n    }\n\n    intro-flow-page {\n        position: fixed;\n        z-index: 0;\n        pointer-events: none;\n        transform: translateX(100%);\n        top: 0;\n    }\n\n    .active {\n        transform: translateX(0%);\n        transition: transform 0.3s ease-in-out;\n        z-index: 4;\n    }\n\n    .left {\n        transform: translateX(-100%);\n        transition: transform 0.3s ease-in-out;\n        z-index: 4;\n    }\n\n    .right {\n        transform: translateX(100%);\n        transition: transform 0.3s ease-in-out;\n        z-index: 4;\n    }\n\n    .place_left {\n        transform: translateX(-100%);\n        z-index: 0;\n        pointer-events: none;\n    }\n\n    .place_right {\n        transform: translateX(100%);\n        z-index: 0;\n        pointer-events: none;\n    }\n\n    .place_active {\n        transform: translateX(0%);\n        z-index: 4;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
